const markMiscTaskAsVerifiedFormInitialValues = comment => {
  const initialValues = {
    comment,
  }

  return initialValues
}

export default markMiscTaskAsVerifiedFormInitialValues
